import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { useEntitlements } from '../context/EntitlementsContext';

/** Pantalla de módulo bloqueado: el módulo se ve, pero pide mejorar el plan. */
export function UpgradeGate({ title, description, benefits = [] }) {
  const { isSuperAdmin } = useAuth();
  const { plan_label: planLabel } = useEntitlements();

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-10 max-w-2xl" data-testid="upgrade-gate">
      <Card className="border-dashed border-[#C58B2A]/40 bg-[#C58B2A]/[0.04]">
        <CardContent className="p-8">
          <div className="w-12 h-12 rounded-2xl bg-[#C58B2A]/12 flex items-center justify-center mb-5">
            <Lock className="w-6 h-6 text-[#C58B2A]" />
          </div>
          <p className="text-[11px] uppercase tracking-wider text-[#C58B2A] font-medium mb-2">
            Mejora tu plan
          </p>
          <h2 className="text-lg md:text-lg font-semibold text-foreground mb-2" data-testid="upgrade-gate-title">
            {title} no está incluido en tu plan
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed mb-5">
            {description || 'Este módulo adicional se contrata aparte.'}
            {planLabel ? ` Tu congregación está en el ${planLabel}.` : ''}
          </p>

          {benefits.length > 0 && (
            <ul className="space-y-2 mb-6">
              {benefits.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Sparkles className="w-4 h-4 text-[#C58B2A] shrink-0 mt-0.5" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}

          {isSuperAdmin ? (
            <Button asChild className="bg-[#056A84] hover:bg-[#045A70] text-white btn-lift">
              <Link to="/subscriptions" data-testid="upgrade-gate-manage">
                Asignar módulo en Suscripciones <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </Button>
          ) : (
            <Button asChild variant="outline" className="btn-lift">
              <Link to="/support" data-testid="upgrade-gate-request">
                Solicitar activación a soporte <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default UpgradeGate;
